










































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class CustomTemplateView extends Vue {
  public items: Common.CustomTemplate[] = new Array();
  public params: Common.CustomTemplateQuery = new Common.CustomTemplateQuery();

  public sortOptions: any = [{ value: 'code', text: 'コンポーネント' }];
}
